import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';
import { TransactionsRequestType } from 'app/utils/services/types/transactions.type';

const refreshToken = localStorage.getItem('refreshToken');

const transactionsService = {
  getTransactions: async (): Promise<any> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get-transactions');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'home-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  filterChangesTransactions: async (data: TransactionsRequestType): Promise<TransactionsRequestType> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/get-transactions', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'home-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getTransferDetails: async (data: any): Promise<any> => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/transfer-details', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'home-page';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useTransactionsService = () => {
  const { isLoading: isLoadingTransactions, data: dataTransactions, refetch: refetchTransactions } = useQuery(
    ['transactions'],
    transactionsService.getTransactions
  );

  return { isLoadingTransactions, dataTransactions, refetchTransactions };
};

export const useFilterChangeTransactions = () => {
  const {
    isLoading: isLoadingFilterTransactions,
    isSuccess: isSuccessFilterTransactions,
    data: dataFilterTransactions,
    mutate: filterTransactionMutation,
  } = useMutation(['filterTransactions'], (data: TransactionsRequestType) =>
    transactionsService.filterChangesTransactions(data)
  );

  return {
    isLoadingFilterTransactions,
    isSuccessFilterTransactions,
    filterTransactionMutation,
    dataFilterTransactions,
  };
};

export const useGetTransferDetails = () => {
  const {
    isSuccess: isSuccessGetTransferDetails,
    isLoading: isLoadingGetTransferDetails,
    data: dataGetTransferDetails,
    mutate: getTransferDetailsMutation,
  } = useMutation(['transferDetails'], (data: any) => transactionsService.getTransferDetails(data));

  return {
    isSuccessGetTransferDetails,
    isLoadingGetTransferDetails,
    dataGetTransferDetails,
    getTransferDetailsMutation,
  };
};
